import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { AppearanceWorkspace } from '@/components/appearance/appearance-workspace'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/appearance')({
  component: AppearancePage,
  staticData: {
    breadcrumbs: [{ label: 'Appearance', href: '/appearance' }],
  } satisfies RouteStaticData,
})

function AppearancePage() {
  return (
    <WorkspaceRouteShell>
      <AppearanceWorkspace />
    </WorkspaceRouteShell>
  )
}
